import { Sparkles, Star, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForWinBackCampaignsAr: TemplateAr = {
  name: 'مكالمات هاتفية بالذكاء الاصطناعي لحملات استعادة العملاء',
  description:
    'مكالمات هاتفية آلية بالذكاء الاصطناعي تعيد تفعيل العملاء المنسحبين بعروض مخصصة وتستعيدهم.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: Users, label: 'عميل منسحب' },
    { icon: Sparkles, label: 'الـ AI يتصل' },
    { icon: Star, label: 'عودة العميل', final: true },
  ],
  detailDescription: {
    paragraph1:
      'استرجع العميل اللي مشى، بمكالمة تسأله وش صار. الـ AI يتصل بعرض مخصص، ويعالج أسباب المغادرة، ويعرض الميزات أو الأسعار الجديدة، ويحاول يعيد تفعيل العلاقة. والمحادثة متعاطفة، ومركّزة على فهم وش ما نجح.',
    paragraph2:
      'نتائج حملات الاستعادة وملاحظات العملاء توصل للـ CRM وأدوات نجاح العملاء عندك. والـ AI يتعلّم وش العروض والرسائل اللي تنجح مع كل شريحة. وأول ما تنجح استعادة، يشتغل سير عمل الإعداد تلقائياً.',
  },
  benefits: [
    'تعيد تفعيل العملاء المنسحبين على نطاق واسع',
    'تعرف وش خلّى عميلك يمشي',
    'كل عرض استعادة مخصص للعميل',
    'القيمة الدائمة للعميل ترتفع',
    'تختبر رسائل الاستعادة تلقائياً',
    'العميل المهتم يوصل لفريق المبيعات',
  ],
};
